import { DetailedTableInfoDc, FailedServiceInfoDc, ServiceInfoDc } from "@evergis/api";
import { createResource } from "@evergis/react-fetching";
import { RangeValue } from "@evergis/ui";

import { api as evergisApi } from "../evergis/api";
import { getLayerInfo } from "../evergis/core/layer/getLayerInfo";
import { isFailedService } from "../interfaces/service";

export type LayerFetchStatus = "layerError" | "tableError";

export function isErrorStatus(status: Nullable<LayerFetchStatus>) {
  return status === "layerError" || status === "tableError";
}

const LAYER_WITH_TABLE_CACHE_SIZE = 1000;

const TABLE_ERRORS = [
  "InvalidDataService",
  "ResourceNotFound",
  "InvalidDataServiceName",
  "InvalidTableName",
  "InvalidIdAttribute",
];

export const layerWithTable = createResource(
  ({
      name,
      // layerInfo,
      defaultScaleRange,
      fetchQueryTable,
    }: {
      name: string;
      layerInfo?: ServiceInfoDc;
      defaultScaleRange: RangeValue;
      fetchQueryTable?: boolean;
    }) =>
    async api => {
      let layer = null;
      let table: DetailedTableInfoDc = null;
      let status: LayerFetchStatus = null;

      try {
        if (name) {
          // temporary removed layers caching because of style bug
          layer = /* layerInfo || */ await api.layers.findOne(name);
        }

        if (isFailedService(layer)) {
          status = "layerError";
        }
      } catch (e) {
        status = "layerError";
      }

      const tableNotFound =
        layer && isFailedService(layer) && TABLE_ERRORS.includes((layer as FailedServiceInfoDc).errorType);

      if (tableNotFound) {
        status = "tableError";
      }

      if (layer && !tableNotFound) {
        try {
          const { tableName } = getLayerInfo(layer, defaultScaleRange);

          if (tableName && layer.type === "PostgresLayerService") {
            table = await api.tables.findOne(tableName);
          }

          if (fetchQueryTable && tableName && layer.type === "QueryLayerService") {
            table = await api.tables.findOne(tableName);
          }
        } catch (e) {
          status = "tableError";
        }
      }

      return {
        data: {
          layer,
          table,
        },
        meta: {
          status,
        },
      };
    },
  {
    injected: evergisApi,
    cacheSize: LAYER_WITH_TABLE_CACHE_SIZE,
  },
);
